/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Department } from '../../models/department';

export interface ApiMasterDepartmentGetActiveGet$Params {
}

export function apiMasterDepartmentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterDepartmentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Department>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterDepartmentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Department>>;
    })
  );
}

apiMasterDepartmentGetActiveGet.PATH = '/api/Master/Department/GetActive';
